import { type ReactElement } from 'react';
import { getRootLayout } from '@/layout';
import { ProfileSidebar } from '@/module/profile/me';
import { useIsSmallerThanTabletSm } from '@/module/public/hooks/useIsSmallerThanTabletSm';
import { PRODUCT_HEADER_HEIGHT } from '@/module/public/layout/productLayoutConstants';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
const ProfileSidebarLayout = ({
  children
}: {
  children: ReactElement;
}) => {
  const isSmallerThanTabletSm = useIsSmallerThanTabletSm();
  const isInExternalPlatform = useIsInExternalPlatform();
  const shouldShowSidebar = !isSmallerThanTabletSm && !isInExternalPlatform;
  if (!shouldShowSidebar) {
    return <main className="pb-[80px] pt-md breakpoint-content-padding tablet-sm:pt-lg">
        {children}
      </main>;
  }
  return <div className="flex w-full bg-default" data-sentry-component="ProfileSidebarLayout" data-sentry-source-file="ProfileSidebarLayout.tsx">
      <div className="flex w-full items-start bg-default">
        <ProfileSidebar style={{
        top: PRODUCT_HEADER_HEIGHT
      }} data-sentry-element="ProfileSidebar" data-sentry-source-file="ProfileSidebarLayout.tsx" />
        <main className="min-w-0 flex-1 pb-[80px] pl-[24px] pr-[40px] pt-none">
          {children}
        </main>
      </div>
    </div>;
};
export function getProfileSidebarLayout(page: ReactElement) {
  return getRootLayout(<ProfileSidebarLayout>{page}</ProfileSidebarLayout>);
}